/* The directory's enlarged map uses the homepage atlas, with one native dialog. */
(() => {
  'use strict';
  if (window.MRGalleryMap) { window.MRGalleryMap.init(document); return; }
  const syncLock = () => document.documentElement.classList.toggle('mr-world-map-open', !!document.querySelector('[data-mr-map-dialog][open]'));
  function mount(root) {
    if (root.dataset.mapReady) return;
    const dialog = root.querySelector('[data-mr-map-dialog]');
    const close = root.querySelector('[data-mr-map-close]');
    const picker = root.querySelector('[data-mr-map-picker]');
    const visit = root.querySelector('[data-mr-map-visit]');
    if (!dialog || !close) return;
    root.dataset.mapReady = 'true';
    let returnFocus = null, openRequest = 0;
    let atlasJob = null;
    function loadAtlas() {
      dialog.querySelectorAll('[data-mr-map-src]').forEach(image => {
        image.src = image.dataset.mrMapSrc;
        image.loading = 'eager'; image.decoding = 'async';
        image.removeAttribute('data-mr-map-src');
      });
      if (window.MRHomeAtlas) return Promise.resolve(true);
      if (atlasJob) return atlasJob;
      const source = dialog.querySelector('[data-atlas-script]')?.dataset.atlasScript;
      if (!source) return Promise.resolve(false);
      atlasJob = new Promise(resolve => {
        const script = document.createElement('script');
        script.src = source; script.async = true;
        script.onload = () => resolve(!!window.MRHomeAtlas);
        script.onerror = () => { script.remove(); atlasJob=null; resolve(false); };
        document.head.append(script);
      });
      return atlasJob;
    }
    const listeners = [];
    const listen = (el, name, fn) => { el.addEventListener(name, fn); listeners.push(() => el.removeEventListener(name, fn)); };
    function open(trigger, region = 'world') {
      returnFocus = trigger;
      if (!dialog.open) dialog.showModal();
      const token = ++openRequest;
      syncLock();
      close.focus({ preventScroll: true });
      loadAtlas().then(loaded => {
        if (!loaded || !dialog.open || token !== openRequest) return;
        window.MRHomeAtlas.init(dialog);
        // Measure only after the native dialog is open, then apply its region.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (dialog.open && token === openRequest) [...dialog.querySelectorAll('[data-atlas-region]')].find(el => el.dataset.atlasRegion === region)?.click();
        }));
      });
    }
    root.querySelectorAll('[data-mr-map-open]').forEach(button => listen(button, 'click', () => open(button)));
    root.querySelectorAll('[data-mr-map-region]').forEach(button => listen(button, 'click', () => open(button, button.dataset.mrMapRegion)));
    listen(close, 'click', () => dialog.close());
    listen(dialog, 'close', () => { syncLock(); if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true }); });
    listen(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
    listen(picker, 'change', () => {
      visit.href = picker.value || '#';
      visit.setAttribute('aria-disabled', String(!picker.value));
      visit.setAttribute('aria-label', picker.value ? 'Open ' + picker.selectedOptions[0].textContent + ' gallery' : 'Open selected gallery');
    });
    listen(visit, 'click', event => { if (!picker.value) event.preventDefault(); });
    try {
      const config = JSON.parse(dialog.querySelector('[data-atlas-data]').textContent);
      const dots = root.querySelector('[data-mr-map-dots]');
      config.destinations.forEach(d => {
        const dot = document.createElement('i');
        dot.style.setProperty('--x', d.x * 100 + '%'); dot.style.setProperty('--y', d.y * 100 + '%'); dots.append(dot);
      });
    } catch (_) { /* The map image and destination picker remain available. */ }
    root.mrMapCleanup = () => { if (dialog.open) dialog.close(); listeners.forEach(fn => fn()); syncLock(); };
  }
  function init(scope) {
    if (scope.matches?.('[data-mr-gallery-map]')) mount(scope);
    scope.querySelectorAll('[data-mr-gallery-map]').forEach(mount);
  }
  window.MRGalleryMap = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-mr-gallery-map]').forEach(root => root.mrMapCleanup?.()));
})();
